<a mat-flat-button (click)="invoke()" *ngIf="params.data.link">
    <mat-icon class="mat-icon material-icons mat-icon-no-color" role="img" aria-hidden="true">open_in_new</mat-icon>
    {{ 'messages.dialog.button_open_case' | translate }}
</a>
<span *ngIf="!params.data.link">-</span>